import { IPois } from './@types/IPoisTileData'

const categoriesOrder = [
  {
    id: 'hipermarket_mulliez',
    order: 1,
  },
  {
    id: 'supermarket_mulliez',
    order: 2,
  },
  {
    id: 'discount_mulliez',
    order: 3,
  },
  {
    id: 'cash&carry_mulliez',
    order: 4,
  },
  {
    id: 'deli_mulliez',
    order: 5,
  },
  {
    id: 'grocery_store_mulliez',
    order: 6,
  },
  {
    id: 'convenience_store_mulliez',
    order: 7,
  },
  {
    id: 'drugstore_mulliez',
    order: 8,
  },
  {
    id: 'household_appliances_store_mulliez',
    order: 9,
  },
  {
    id: 'diy_mulliez',
    order: 10,
  },
  {
    id: 'furniture_store_mulliez',
    order: 11,
  },
  {
    id: 'homeware_store_mulliez',
    order: 12,
  },
  {
    id: 'grocery store',
    order: 13,
  },
  {
    id: 'butcher',
    order: 14,
  },
  {
    id: 'bakery',
    order: 15,
  },
  {
    id: 'restaurant',
    order: 16,
  },
  {
    id: 'fast food',
    order: 17,
  },
  {
    id: 'cafe',
    order: 18,
  },
  {
    id: 'pub',
    order: 19,
  },
  {
    id: 'drugstore',
    order: 20,
  },
  {
    id: 'pharmacy',
    order: 21,
  },
  {
    id: 'bank',
    order: 22,
  },
  {
    id: 'atm',
    order: 23,
  },
  {
    id: 'construction store',
    order: 24,
  },
  {
    id: 'jewellery store',
    order: 25,
  },
  {
    id: 'gym',
    order: 26,
  },
  {
    id: 'shopping center',
    order: 27,
  },
  {
    id: 'non food discount',
    order: 28,
  },
  {
    id: 'petrol station',
    order: 29,
  },
  {
    id: 'pudo',
    order: 30,
  },
  {
    id: 'book store',
    order: 31,
  },
  {
    id: 'furniture store',
    order: 32,
  },
  {
    id: 'nursery',
    order: 33,
  },
  {
    id: 'school',
    order: 34,
  },
  {
    id: 'kindergarten',
    order: 35,
  },
  {
    id: 'cultural place',
    order: 36,
  },
]

export const sortCategories = (rows: {[key: string]: IPois[] }) : {[key: string]: IPois[] } =>
  Object.fromEntries(Object.entries(rows).sort((a, b) => {
    const itemA = categoriesOrder?.find(item => item?.id === a[0]) || {
      id: a[0],
      order: 100,
    }
    const itemB = categoriesOrder?.find(item => item?.id === b[0]) || {
      id: b[0],
      order: 100,
    }
    return itemA?.order - itemB?.order
  }))

export const sortCategoriesNestedSelectList = (list: {
  id: string;
  content: string;
}[]): {
  id: string;
  content: string;
}[] => list.sort((a, b) => {
  const itemA = categoriesOrder?.find(item => item?.id === a.id) || {
    id: a.id,
    order: 100,
  }
  const itemB = categoriesOrder?.find(item => item?.id === b.id) || {
    id: b.id,
    order: 100,
  }
  return itemA?.order - itemB?.order
})
